import { render } from "./ManageThemeTerminology.vue?vue&type=template&id=00c14aec&lang=pug"
import script from "./ManageThemeTerminology.vue?vue&type=script&lang=js"
export * from "./ManageThemeTerminology.vue?vue&type=script&lang=js"

import "./ManageThemeTerminology.vue?vue&type=style&index=0&id=00c14aec&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__